import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { atualizaCampoEmEndicao, atualizaStateCampo, defineAttr, defineCarregadoComSucesso, salvarNota, triggerCarregaDB, triggerSalvarNota } from "./NotetakerSlice";
import { server_url } from "../core/config_geral";
import axios from "axios";
import { generalErrorAction, publicarError } from "../helper/general-error/GeneralErrorSlice";
import { isNotNull } from "../helper/functions";

function* doListenCarregaDB() {

    // var r = localStorage.getItem("tmp_notas")
    // console.log(r)
    // yield atualizaAtributo("data", JSON.parse(r))
    // yield put(defineCarregadoComSucesso(true))

    // return

    yield atualizaAtributo("processando", true)
    yield atualizaAtributo("statusText", "Baixando banco de dados...")

    var key = yield select((state) => state.notetaker.encryptKey)
    var token = yield select((state) => state.auth.token)

    var r = yield call(() => axios.get(server_url + "/storage/buckets/anano.notetaker/arquivos/e8ae53eb-7b5b-49e0-a574-513332c1f7db", 
    {
        headers : {
            'Authorization' : 'Bearer ' + token
        }
    }).then(response => response)
    .catch(error => error))

    if (r.code == "ERR_NETWORK") {

        yield atualizaAtributo("statusText", "Erro de conexão")
        yield put(publicarError(generalErrorAction(
            "NotetakerSaga.doListenCarregaDB",
            isNotNull(r.code) ? r.code : "",
            isNotNull(r.response) ? r.response.status : "",
            isNotNull(r.message) ? r.message : "",
            r
        )))
        return
    }

    var versao = r.data.version

    yield atualizaAtributo("fileVersion", versao)

    r = yield call(() => axios.get(server_url + "/storage/dw/buckets/anano.notetaker/arquivos/e8ae53eb-7b5b-49e0-a574-513332c1f7db/download?access_token=" + token + "&encrypt_key=" + key,).catch(error => error))

    yield atualizaAtributo("processando", false)


    if (r.status && r.status == 200) {
        yield atualizaAtributo("statusText", "Baixado com sucesso")
        yield atualizaAtributo("data", r.data)
        yield atualizaAtributo("versaoArquivo", )
        localStorage.setItem("tmp_notas", JSON.stringify(r.data))
        yield put(defineCarregadoComSucesso(true))
    } else {

        yield atualizaAtributo("statusText", "Não conseguiu baixar, verifique a senha.")

        if (r.code == "ERR_NETWORK") {

            yield atualizaAtributo("statusText", "Erro de conexão")
            yield put(publicarError(generalErrorAction(
                "NotetakerSaga.doListenCarregaDB",
                isNotNull(r.code) ? r.code : "",
                isNotNull(r.response) ? r.response.status : "",
                isNotNull(r.message) ? r.message : "",
                r
            )))

        }
    }

}

function* atualizaAtributo(campo, valor) {
    yield put(defineAttr({
        campo,
        value: valor
    }))
}

function* setEdicaoError(value) {
    yield put(atualizaStateCampo({ campo: "edicaoError", value: value }))
}

function* setEdicaoProcessando(value) {
    yield put(atualizaStateCampo({ campo: "edicaoProcessando", value: value }))
}

function* doListenSalvarNota(action) {

    var token = yield select((state) => state.auth.token)
    yield setEdicaoError(null)
    yield setEdicaoProcessando(true)

    yield delay(200)

    var nota = action.payload.nota

    var version = yield select((state) => state.notetaker.fileVersion)

    if (nota.titulo.trim().length == 0) {
        yield setEdicaoError("Título inválido")
        yield setEdicaoProcessando(false)
    } else {
        yield put(salvarNota(nota))

        var data = yield select((state) => state.notetaker.data)

        localStorage.setItem("tmp_notas", JSON.stringify(data))

        // console.log(btoa(JSON.stringify(data)))
        var payload = {
            remetente : "anano.notetaker",
            nome : "notas-db",
            bucket : "anano.notetaker",
            path : "",
            encryptKey : "oi110789",
            version : version
        }

        var formData = new FormData()
        formData.append("file",
        new Blob([JSON.stringify(data)], {
            type : "application/json"
        })) 
        formData.append("data", 
            new Blob([JSON.stringify(payload)], {
                type : "application/json"
            })) 

        var r = yield call(() => axios.post(server_url + "/storage",
        formData,{
            headers : {
                'Content-Type' : 'multipart/form-data',
                'Authorization' : 'Bearer ' + token
            }
        }).then(response => response)
        .catch(error => error))

        if (r.status && r.status == 200) {
            yield put(atualizaStateCampo({campo: "fileVersion", value : version + 1}))
            if (action.payload.redirectAfter) {
                yield put(atualizaStateCampo({campo: "redirectAfter", value: true}))
                yield delay(200)
                yield put(atualizaStateCampo({campo: "redirectAfter", value: false}))
            }
        } else {
    
            yield atualizaAtributo("edicaoError", "Erro ao salvar arquivo, mensagem não encontrada.")

            // console.log(r)

            if(isNotNull(r.response)) {
                if(isNotNull(r.response.data)) {
                    if(isNotNull(r.response.data.mensagem)){
                        yield atualizaAtributo("edicaoError", r.response.data.mensagem)
                    }
                }
            }
    
            if (r.code == "ERR_NETWORK") {
    
                yield atualizaAtributo("statusText", "Erro de conexão")
                yield put(publicarError(generalErrorAction(
                    "NotetakerSaga.doListenCarregaDB",
                    isNotNull(r.code) ? r.code : "",
                    isNotNull(r.response) ? r.response.status : "",
                    isNotNull(r.message) ? r.message : "",
                    r
                )))
    
            }
        }

        yield setEdicaoProcessando(false)
        
    }

}

export function* listenEnviaForm() {
    yield takeLatest(triggerCarregaDB, doListenCarregaDB)
}

export function* listenSalvarNota() {
    yield takeLatest(triggerSalvarNota, doListenSalvarNota)
}